import produce from 'immer';

import {
  FETCH_FAVORITE_DRAMAS_REQUESTING,
  FETCH_FAVORITE_DRAMAS_ABORTED,
  FETCH_FAVORITE_DRAMAS_FAILED,
  FETCH_FAVORITE_DRAMAS_SUCCEEDED,
  LOGOUT,
} from '../../constants/actionTypes';

import {
  REQUEST_STATE_READY,
  REQUEST_STATE_REQUESTING,
  REQUEST_STATE_ABORTED,
  REQUEST_STATE_FAILED,
  REQUEST_STATE_SUCCEEDED,
} from '../../../constants/state';

const initState = REQUEST_STATE_READY;

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_FAVORITE_DRAMAS_REQUESTING: {
      return REQUEST_STATE_REQUESTING;
    }

    case FETCH_FAVORITE_DRAMAS_ABORTED: {
      return REQUEST_STATE_ABORTED;
    }

    case FETCH_FAVORITE_DRAMAS_FAILED: {
      return REQUEST_STATE_FAILED;
    }

    case FETCH_FAVORITE_DRAMAS_SUCCEEDED: {
      return REQUEST_STATE_SUCCEEDED;
    }

    case LOGOUT: {
      return initState;
    }
  }
}, initState);
